export default class OnboardingStepEvent {
    constructor(type, stepId) {
        this._type = type;
        this._stepId = stepId;
    }

    get type() {
        return this._type;
    }

    get stepId() {
        return this._stepId;
    }
}

OnboardingStepEvent.SHOW_ONBOARDING_STEP = "OnboardingStepEvent.SHOW_ONBOARDING_STEP";
OnboardingStepEvent.FINISH_ONBOARDING_STEP = "OnboardingStepEvent.FINISH_ONBOARDING_STEP";